import { ApiEndpoint } from "./endpoints";
import { get, getPaginated, post, patch } from './client';
import { ApiResponse } from './dispatcher';
import { isAfter } from 'date-fns';

export interface PaymentItem {
	name: string;
	amount: number;
}

export interface PaymentLogItem {
	id: string;
	message: string;
	paymentId: string;
	createdAt: string;
	type: "info" | "warning" | "error";
}

export interface Payment {
	id?: string;
	reservationId?: string;
	inquiryId?: string;
	amount: number;
	currency: string;
	state?: "awaiting_payment" | "expired" | "completed" | "pending";
	requestId?: string;
	transactionId?: string;
	completionTime?: string;
	expirationDate?: string;
	creationDate?: string;
	methodName?: string;
	items: PaymentItem[];
	log?: PaymentLogItem[];
	name: string;
	email: string;
	message?: string;
	payment?: Payment;
};

export interface PaymentResponse extends ApiResponse {
	data: Payment[];
}

export const getPayments = async (page: number, limit = 25) => {
	const r = await getPaginated(ApiEndpoint.Payments, page, limit) as PaymentResponse;

	return {
		...r,
		data: processPayments(r.data)
	};
};

export const addPayment = async (payment: Payment): Promise<Payment> => {
	const r = await post(ApiEndpoint.Payments, payment);

	return r;
};

export const updatePayment = async (id: string, data: Payment) => {
	const r = (await patch(
		ApiEndpoint.Payments,
		id,
		data
	)) as Payment;

	return processPayments([r])[0];
};

const processPayments = (payments: Payment[]): Payment[] => {
	return payments.map(payment => {
		if (
			payment.state === "awaiting_payment"
			&& isAfter(new Date(), new Date(payment.expirationDate))
		) {
			payment.state = "expired";
		}

		return payment;
	});
};
